(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};
  if (registry.productFinalCta) {
    registry.productFinalCta(document);
    return;
  }
  function initSection(section) {
    if (section.dataset.finalCtaReady === 'true') return;
    section.dataset.finalCtaReady = 'true';

    var variantSelect = section.querySelector('[data-final-cta-variant]');
    if (!variantSelect) return;

    var price = section.querySelector('[data-final-cta-price]');
    var priceLabel = section.querySelector('[data-final-cta-price-label]');
    var compare = section.querySelector('[data-final-cta-compare]');
    var compareWrap = section.querySelector('[data-final-cta-compare-wrap]');
    var submit = section.querySelector('[data-final-cta-submit]');
    var buttonLabel = section.querySelector('[data-final-cta-button-label]');
    var availability = section.querySelector('[data-final-cta-availability]');
    var availabilityLabel = section.querySelector('[data-final-cta-availability-label]');

    function updateVariant() {
      var option = variantSelect.options[variantSelect.selectedIndex];
      if (!option) return;

      var isAvailable = option.dataset.available === 'true';
      var comparePrice = option.dataset.compare || '';

      if (price) price.textContent = option.dataset.price || '';
      if (priceLabel) priceLabel.textContent = comparePrice ? 'Sale price' : 'Regular price';
      if (compare) compare.textContent = comparePrice;
      if (compareWrap) compareWrap.hidden = !comparePrice;

      if (submit) {
        submit.disabled = !isAvailable;
        if (buttonLabel) {
          buttonLabel.textContent = isAvailable
            ? submit.dataset.availableLabel
            : submit.dataset.soldOutLabel;
        }
      }

      if (availability) availability.classList.toggle('is-sold-out', !isAvailable);
      if (availabilityLabel) {
        availabilityLabel.textContent = isAvailable
          ? availabilityLabel.getAttribute('data-available-text') || 'Ready to ship'
          : submit.dataset.soldOutLabel;
      }
    }

    if (availabilityLabel) {
      availabilityLabel.setAttribute('data-available-text', availabilityLabel.textContent.trim());
    }
    variantSelect.addEventListener('change', updateVariant);
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-product-final-cta]')) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll('[data-product-final-cta]') : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  registry.productFinalCta = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initAll(event.target);
  });
})();
